import React from "react";
import classes from "./ToggleBtn.module.css";


const ToggleBtn = ({ isChecked, onClickFunc }) => {

    return (
        <div className={`${classes.ToggleBtn} ${isChecked && classes.Chosen}`} onClick={onClickFunc}>
            <input className={classes.CheckInput} type="checkbox" id="flexSwitchCheckDefault" checked={isChecked} onChange={() => console.log('ToggleBtn input changed!')} />
            <span className={classes.Slider}></span>
        </div>
    )
}
export default ToggleBtn